import 'swiper/css'
import 'swiper/css/pagination'

import { Swiper, Pagination } from 'swiper'

const menuSection = document.querySelector('.menu')
if (menuSection) {
  const gals = menuSection.querySelectorAll('.menu-gal')
  gals.forEach(item => {
    const pagination = item.querySelector('.swiper-pagination')

    new Swiper(item, {
      modules: [Pagination],
      slidesPerView: 1.15,
      spaceBetween: 16,
      pagination: {
        el: pagination,
        type: 'bullets',
      },
      breakpoints: {
        480: {
          slidesPerView: 1.4
        },
        768: {
          slidesPerView: 1
        }
      }
    })
  })
}